"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericLogStatus = void 0;
var GenericLogStatus;
exports.GenericLogStatus = GenericLogStatus;

(function (GenericLogStatus) {
  GenericLogStatus["LIMIT_EXCEEDED"] = "limit_exceeded";
  GenericLogStatus["LIMIT_WARNING"] = "limit_warning";
  GenericLogStatus["CLEAN"] = "clean";
})(GenericLogStatus || (exports.GenericLogStatus = GenericLogStatus = {}));